// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"styles_sectionContainer___Y_IF","elementContainer":"styles_elementContainer__eG3p6"};